/**
 * @generated SignedSource<<bb3ad3166a68533e47d2d8eec710fc3f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actionsAndContent_AtlassianEditionAwareness$data = {
  readonly confluence_storage?: {
    readonly bytesUsed: AGG$Long;
  } | null | undefined;
  readonly jira?: {
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly latestUsageForChargeElement?: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "actionsAndContent_AtlassianEditionAwareness";
};
export type actionsAndContent_AtlassianEditionAwareness$key = {
  readonly " $data"?: actionsAndContent_AtlassianEditionAwareness$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionsAndContent_AtlassianEditionAwareness">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "applicationKey"
    },
    {
      "kind": "RootArgument",
      "name": "chargeElement"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "entitlementFilter"
    },
    {
      "kind": "RootArgument",
      "name": "productKey"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckForChargeQuantities"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckForStorageUsageConfluence"
    },
    {
      "kind": "RootArgument",
      "name": "shouldCheckForStorageUsageJira"
    },
    {
      "kind": "RootArgument",
      "name": "shouldSkip"
    }
  ],
  "kind": "Fragment",
  "name": "actionsAndContent_AtlassianEditionAwareness",
  "selections": [
    {
      "condition": "shouldSkip",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "cloudIds.0",
                  "variableName": "cloudId"
                }
              ],
              "kind": "ListValue",
              "name": "cloudIds"
            }
          ],
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "hamsProductKey",
                  "variableName": "productKey"
                }
              ],
              "kind": "LinkedField",
              "name": "entitlementInfo",
              "plural": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "where",
                      "variableName": "entitlementFilter"
                    }
                  ],
                  "kind": "LinkedField",
                  "name": "entitlement",
                  "plural": false,
                  "selections": [
                    {
                      "condition": "shouldCheckForChargeQuantities",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "chargeElement",
                              "variableName": "chargeElement"
                            }
                          ],
                          "kind": "ScalarField",
                          "name": "latestUsageForChargeElement"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "shouldCheckForStorageUsageJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "applicationKey",
                  "variableName": "applicationKey"
                },
                (v0/*: any*/)
              ],
              "kind": "ScalarField",
              "name": "attachmentStorageUsed"
            }
          ]
        }
      ]
    },
    {
      "condition": "shouldCheckForStorageUsageConfluence",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "ConfluenceStorage",
          "kind": "LinkedField",
          "name": "confluence_storage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "bytesUsed"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "44fed4ce994b2c1bda59e3db176a3353";

export default node;
